import {
  DeleteOutlined,
  EditOutlined,
  MailOutlined,
  PlusOutlined,
  ShoppingCartOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Col,
  Empty,
  Input,
  InputNumber,
  Modal,
  PageHeader,
  Row,
  Select,
  Space,
  Spin,
  Steps,
  Table,
  Tag,
  Timeline,
  Tooltip,
  Upload,
  message,
  notification,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  DatePickerItem,
  DynamicCardForm,
  ErrorItem,
  Form,
  FormItem,
  InputItem,
  SelectItem,
  TextAreaItem,
  claveFechaDia,
  fechaDiaParaPayload,
  fmtFechaDia,
} from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import MandarCorreoRMA from "../MandarCorreoRMA/MandarCorreoRMA";
import ElegirRenglonesVentaRMA from "./ElegirRenglonesVentaRMA";
import ModalRenglonLibreRMA from "./ModalRenglonLibreRMA";
import {
  ESTADOS_EDITABLES,
  ESTADOS_RMA,
  ETIQUETA_ESTADO_RMA,
  PASOS_RMA,
  cantidadTexto,
  dinero,
  importeConImpuestosMXN,
  pasoDeEstado,
} from "../rmaComun";

const { Option } = Select;

/*
  Evidencias del RMA (fotos, videos, PDFs). Viven en this.state.evidencias y no en el form:
  un FormItem con name sobre un Upload guarda el evento de antd, no la lista. Las nuevas
  traen `originFileObj` y viajan en base64 al guardar; las guardadas se hidratan con
  `urlRelativa` para que la vista previa las pida al backend.
*/
const LIMITE_ARCHIVO_MB = 20;
const EXTENSIONES_PREVISUALIZABLES = ["pdf", "png", "jpg", "jpeg", "webp", "gif"];
const ENDPOINT_ARCHIVO = "rma/obtenerArchivoRMABase64";

const extensionDe = (nombre = "") => (nombre.includes(".") ? nombre.split(".").pop().toLowerCase() : "");

const getBase64 = (archivo) =>
  new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.readAsDataURL(archivo);
    lector.onload = () => resolve(lector.result);
    lector.onerror = reject;
  });

const descargarBlob = (blob, nombre) => {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = nombre || "archivo";
  enlace.click();
  URL.revokeObjectURL(url);
};

const archivosDesdeBackend = (archivos = []) =>
  archivos.map((archivo, indice) => ({
    uid: `guardado-${indice}-${archivo.url}`,
    name: archivo.name,
    status: "done",
    cargadoDesdeBackend: true,
    urlRelativa: archivo.url,
  }));

let contadorLlaves = 0;
const nuevaLlave = () => `nuevo-${Date.now()}-${contadorLlaves++}`;

// Los renglones viven en el state (no en un Form.List): cada fila trae datos de solo
// lectura que manda el servidor y solo se capturan cantidad y observaciones.
const conLlave = (renglon) => ({ ...renglon, _llave: renglon._id ? String(renglon._id) : nuevaLlave() });

const renglonParaGuardar = (renglon) =>
  renglon.libre
    ? {
        ...(renglon._id ? { _id: renglon._id } : {}),
        libre: true,
        insumoId: renglon.insumoId || undefined,
        descripcion: renglon.descripcion,
        cantidadSolicitada: renglon.cantidadSolicitada,
        precioUnitarioNeto: renglon.precioUnitarioNeto,
        observaciones: renglon.observaciones || "",
      }
    : {
        ...(renglon._id ? { _id: renglon._id } : {}),
        ventaId: renglon.ventaId,
        ventaRenglonId: renglon.ventaRenglonId,
        cantidadSolicitada: renglon.cantidadSolicitada,
        observaciones: renglon.observaciones || "",
      };

/*
  Modo determinado por location.state:
    - sin id                 → Agregar
    - { id, modo: "editar" } → Editar (solo borrador o rechazado)
    - { id, modo: "ver" }    → Ver
*/
class VistaRMA extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    rma: null,
    folioSugerido: "",
    motivos: [],
    diasPlazo: null,
    abreviacionesMoneda: {},
    clienteId: undefined,
    renglones: [],
    evidencias: [],
    archivoVer: null,
    modalVentaVisible: false,
    modalLibreVisible: false,
    modalCorreoVisible: false,
  };

  get modo() {
    return this.props.location?.state?.modo || (this.id ? "ver" : "agregar");
  }

  get id() {
    return this.props.location?.state?.id || null;
  }

  componentDidMount() {
    this.consultarConfiguracion();
    if (this.id) {
      this.consultarRMA(this.id);
    } else {
      this.formRef.current?.setFieldsValue({ fechaSolicitud: moment() });
    }
  }

  consultarConfiguracion() {
    axios
      .post("rma/siguienteFolioRMA", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) return;
        this.setState({
          folioSugerido: res.data.folio,
          motivos: res.data.motivos || [],
          diasPlazo: res.data.diasPlazo ?? null,
        });
      });
  }

  consultarRMA(id) {
    this.setState({ loading: true });
    axios
      .post("rma/datosRMA", { empresaId: this.props.empresaId, rmaId: id }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loading: false });
          message.error(res.data.message || "No se encontró el RMA");
          return;
        }
        const rma = res.data.rma;
        this.setState({
          loading: false,
          rma,
          clienteId: rma.clienteId,
          abreviacionesMoneda: res.data.abreviacionesMoneda || {},
          renglones: (rma.renglones || []).map(conLlave),
          evidencias: archivosDesdeBackend(rma.evidencias || []),
        });
        this.formRef.current?.setFieldsValue({
          clienteId: rma.clienteId,
          fechaSolicitud: rma.fechaSolicitud ? moment(rma.fechaSolicitud) : undefined,
          motivo: rma.motivo,
          descripcion: rma.descripcion,
          contacto: rma.contacto,
          correoContacto: rma.correoContacto,
          telefonoContacto: rma.telefonoContacto,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudo cargar el RMA");
      });
  }

  atras() {
    this.props.history.goBack();
  }

  editar() {
    this.props.history.replace("/panel/vistaRMA", { id: this.id, modo: "editar" });
  }

  onValuesChange(cambios) {
    // El resumen calcula el plazo con la fecha del form, que no re-renderiza esta pantalla.
    if (Object.prototype.hasOwnProperty.call(cambios, "fechaSolicitud")) this.forceUpdate();
    if (!Object.prototype.hasOwnProperty.call(cambios, "clienteId")) return;
    const clienteNuevo = cambios.clienteId;
    const clienteAnterior = this.state.clienteId;
    if (String(clienteNuevo || "") === String(clienteAnterior || "")) return;

    const deVentas = this.state.renglones.filter((renglon) => !renglon.libre);
    if (deVentas.length === 0 || !clienteAnterior) {
      this.setState({ clienteId: clienteNuevo });
      return;
    }
    // Los renglones de venta son del cliente anterior: cambiarlo los quita.
    Modal.confirm({
      title: "¿Cambiar de cliente?",
      content: `Se quitarán ${deVentas.length} renglón(es) que vienen de ventas del cliente anterior.`,
      okText: "Cambiar",
      cancelText: "Regresar",
      onOk: () =>
        this.setState((anterior) => ({
          clienteId: clienteNuevo,
          renglones: anterior.renglones.filter((renglon) => renglon.libre),
        })),
      onCancel: () => this.formRef.current?.setFieldsValue({ clienteId: clienteAnterior }),
    });
  }

  agregarRenglonesDeVenta(elegidos) {
    this.setState((anterior) => ({
      modalVentaVisible: false,
      renglones: [...anterior.renglones, ...elegidos.map(conLlave)],
    }));
  }

  agregarRenglonLibre(renglon) {
    this.setState((anterior) => ({
      modalLibreVisible: false,
      renglones: [...anterior.renglones, conLlave(renglon)],
    }));
  }

  cambiarRenglon(llave, campo, valor) {
    this.setState((anterior) => ({
      renglones: anterior.renglones.map((renglon) => (renglon._llave === llave ? { ...renglon, [campo]: valor } : renglon)),
    }));
  }

  quitarRenglon(llave) {
    this.setState((anterior) => ({ renglones: anterior.renglones.filter((renglon) => renglon._llave !== llave) }));
  }

  // ---------------------------------------------------------------- evidencias --

  agregarArchivo = (archivo) => {
    if (archivo.size / (1024 * 1024) > LIMITE_ARCHIVO_MB) {
      message.error(`${archivo.name} pesa más de ${LIMITE_ARCHIVO_MB} MB`);
      return Upload.LIST_IGNORE;
    }
    this.setState((anterior) => ({
      evidencias: [...anterior.evidencias, { uid: archivo.uid, name: archivo.name, status: "done", originFileObj: archivo }],
    }));
    return false;
  };

  quitarArchivo = (archivo) => {
    this.setState((anterior) => ({ evidencias: anterior.evidencias.filter((item) => item.uid !== archivo.uid) }));
  };

  verArchivo = (archivo) => {
    if (EXTENSIONES_PREVISUALIZABLES.includes(extensionDe(archivo.name))) {
      this.setState({ archivoVer: archivo });
    } else {
      this.descargarArchivo(archivo);
    }
  };

  descargarArchivo = (archivo) => {
    if (archivo.originFileObj) return descargarBlob(archivo.originFileObj, archivo.name);
    axios
      .post(
        ENDPOINT_ARCHIVO,
        { empresaId: this.props.empresaId, rmaId: this.id, archivoPath: archivo.urlRelativa },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2 || !res.data.base64) return message.error("No se pudo descargar el archivo");
        const bytes = Uint8Array.from(atob(res.data.base64), (caracter) => caracter.charCodeAt(0));
        descargarBlob(new Blob([bytes], { type: res.data.mime }), archivo.name || res.data.name);
      })
      .catch(() => message.error("No se pudo descargar el archivo"));
  };

  evidenciasParaGuardar() {
    return Promise.all(
      this.state.evidencias.map(async (archivo) =>
        archivo.originFileObj
          ? { name: archivo.name, url: await getBase64(archivo.originFileObj) }
          : { name: archivo.name, url: archivo.urlRelativa }
      )
    );
  }

  // ------------------------------------------------------------------- guardar --

  // Se valida y se guarda directo (sin form.submit): el Form de la casa ignora un segundo
  // envio durante 5 s, y aqui es normal corregir una cantidad que el servidor rechazo.
  async guardar() {
    let valores;
    try {
      valores = await this.formRef.current.validateFields();
    } catch (e) {
      return ErrorItem(e);
    }
    if (this.state.renglones.length === 0) return message.warning("Agrega al menos un renglón al RMA");
    const sinCantidad = this.state.renglones.find((renglon) => !(Number(renglon.cantidadSolicitada) > 0));
    if (sinCantidad) return message.warning(`Captura la cantidad de "${sinCantidad.descripcion}"`);

    let evidencias;
    try {
      evidencias = await this.evidenciasParaGuardar();
    } catch (e) {
      return message.error("No se pudieron leer las evidencias");
    }

    const esEditar = this.modo === "editar";
    this.setState({ loading: true });
    axios
      .post(
        esEditar ? "rma/editarRMA" : "rma/agregarRMA",
        {
          ...valores,
          fechaSolicitud: fechaDiaParaPayload(valores.fechaSolicitud),
          renglones: this.state.renglones.map(renglonParaGuardar),
          evidencias,
          empresaId: this.props.empresaId,
          ...(esEditar ? { rmaId: this.id } : {}),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const id = esEditar ? this.id : res.data.rmaId;
          message.success(esEditar ? "Se guardó el RMA" : `Se creó el RMA ${res.data.folio || ""}`);
          this.props.history.replace("/panel/vistaRMA", { id, modo: "ver" });
          this.consultarRMA(id);
        } else if (res.data.success === 1) {
          const errores = res.data.errores || [res.data.message];
          if (errores.length > 1) {
            notification.error({
              message: "No se pudo guardar el RMA",
              description: (
                <ul style={{ paddingLeft: 18, margin: 0 }}>
                  {errores.map((error, indice) => (
                    <li key={indice}>{error}</li>
                  ))}
                </ul>
              ),
              duration: 10,
            });
          } else {
            message.error(errores[0] || "No se pudo guardar el RMA");
          }
        } else {
          message.error("Hubo un error y el RMA no se guardó");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error y el RMA no se guardó");
      });
  }

  // ------------------------------------------------------------------- render --

  // Vista previa del plazo: el que vale lo calcula el servidor al guardar.
  plazoPreview() {
    const fechaSolicitud = this.formRef.current?.getFieldValue("fechaSolicitud");
    const claveSolicitud = claveFechaDia(fechaSolicitud || new Date());
    const dias = this.state.renglones
      .filter((renglon) => !renglon.libre && renglon.fechaVenta)
      .map((renglon) => moment(claveSolicitud, "YYYY-MM-DD").diff(moment(claveFechaDia(renglon.fechaVenta), "YYYY-MM-DD"), "days"));
    const diasDesdeVenta = dias.length ? Math.max(...dias) : null;
    const plazo = this.state.diasPlazo;
    return {
      diasDesdeVenta,
      diasPlazo: plazo,
      fueraDePlazo: plazo !== null && plazo !== undefined && diasDesdeVenta !== null && diasDesdeVenta > plazo,
    };
  }

  columnasRenglones(soloLectura) {
    const abreviaciones = this.state.abreviacionesMoneda;
    return [
      {
        title: "Origen",
        key: "origen",
        width: 120,
        render: (value, renglon) =>
          renglon.libre ? (
            <Tag>Sin venta</Tag>
          ) : (
            <>
              <div>{renglon.ventaSerieNumero}</div>
              <div style={{ fontSize: 11, color: "#8c8c8c" }}>{fmtFechaDia(renglon.fechaVenta)}</div>
            </>
          ),
      },
      { title: "Código", dataIndex: "codigo", key: "codigo", width: 80 },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        render: (value, renglon) => (
          <>
            <div>{value}</div>
            <div style={{ marginTop: 2 }}>
              {renglon.esKit && <Tag color="purple">Kit</Tag>}
              {renglon.controlaLotes && <Tag>Lotes</Tag>}
              {renglon.enFacturaGlobal && (
                <Tooltip title="Incluida en factura global: no admite nota de crédito desde el RMA">
                  <Tag color="orange">Factura global</Tag>
                </Tooltip>
              )}
            </div>
            {soloLectura ? (
              renglon.observaciones ? (
                <div style={{ fontSize: 11, color: "#8c8c8c" }}>{renglon.observaciones}</div>
              ) : null
            ) : (
              <Input
                size="small"
                placeholder="Observaciones del renglón"
                value={renglon.observaciones}
                onChange={(e) => this.cambiarRenglon(renglon._llave, "observaciones", e.target.value)}
                style={{ marginTop: 4 }}
              />
            )}
          </>
        ),
      },
      {
        title: "Vendido",
        dataIndex: "cantidadVendida",
        key: "cantidadVendida",
        width: 75,
        align: "center",
        render: (value, renglon) => (renglon.libre ? "—" : cantidadTexto(value)),
      },
      {
        title: "A devolver",
        dataIndex: "cantidadSolicitada",
        key: "cantidadSolicitada",
        width: 110,
        align: "center",
        render: (value, renglon) =>
          soloLectura ? (
            cantidadTexto(value)
          ) : (
            <InputNumber
              size="small"
              min={0}
              max={renglon.pendiente !== undefined ? renglon.pendiente : undefined}
              value={value}
              onChange={(cantidad) => this.cambiarRenglon(renglon._llave, "cantidadSolicitada", cantidad)}
              style={{ width: "100%" }}
            />
          ),
      },
      {
        title: "Precio neto",
        dataIndex: "precioUnitarioNeto",
        key: "precioUnitarioNeto",
        width: 120,
        align: "right",
        render: (value, renglon) =>
          `${dinero(value)} ${renglon.libre ? "MXN" : abreviaciones[String(renglon.monedaId)] || ""}`.trim(),
      },
      {
        title: "Importe c/imp. (MXN)",
        key: "importe",
        width: 130,
        align: "right",
        render: (value, renglon) => dinero(importeConImpuestosMXN(renglon.cantidadSolicitada, renglon)),
      },
      ...(soloLectura
        ? []
        : [
            {
              title: "",
              key: "quitar",
              width: 44,
              render: (value, renglon) => (
                <ButtonItem
                  type="default"
                  size="small"
                  rojo
                  icon={<DeleteOutlined />}
                  onClick={() => this.quitarRenglon(renglon._llave)}
                />
              ),
            },
          ]),
    ];
  }

  renderResumen() {
    const { rma, renglones } = this.state;
    const montoPreview = renglones.reduce(
      (suma, renglon) => suma + importeConImpuestosMXN(renglon.cantidadSolicitada, renglon),
      0
    );
    const plazo = this.plazoPreview();
    const guardadoSinCambios = rma && this.modo === "ver";
    const fueraDePlazo = guardadoSinCambios ? rma.fueraDePlazo : plazo.fueraDePlazo;
    const diasDesdeVenta = guardadoSinCambios ? rma.diasDesdeVenta : plazo.diasDesdeVenta;
    const diasPlazo = guardadoSinCambios ? rma.diasPlazo : plazo.diasPlazo;

    return (
      <DynamicCardForm title="Resumen" xs={24} lg={8}>
        <div style={{ fontSize: 12, color: "#8c8c8c" }}>Monto estimado con impuestos</div>
        <div style={{ fontSize: 22, fontWeight: 600 }}>
          {dinero(guardadoSinCambios ? rma.montoSolicitado : Math.round(montoPreview * 100) / 100)} MXN
        </div>
        {rma?.montoAutorizado !== undefined && rma?.montoAutorizado !== null && (
          <div style={{ fontSize: 12 }}>Autorizado: {dinero(rma.montoAutorizado)} MXN</div>
        )}
        <div style={{ marginTop: 12, fontSize: 12 }}>
          <div>
            Días desde la venta más antigua: <b>{diasDesdeVenta !== null && diasDesdeVenta !== undefined ? diasDesdeVenta : "—"}</b>
          </div>
          <div>
            Plazo de la empresa: <b>{diasPlazo !== null && diasPlazo !== undefined ? `${diasPlazo} días` : "Sin plazo"}</b>
          </div>
        </div>
        {fueraDePlazo && (
          <Alert
            type="warning"
            showIcon
            style={{ marginTop: 10 }}
            message="Fuera de plazo"
            description="Además de la autorización por monto, el RMA va a pedir la autorización de fuera de plazo."
          />
        )}
      </DynamicCardForm>
    );
  }

  renderSeguimiento() {
    const seguimiento = this.state.rma?.seguimiento || [];
    if (seguimiento.length === 0) return null;
    return (
      <DynamicCardForm title="Seguimiento" xs={24} collapsable defaultOpen={false}>
        <Timeline style={{ marginTop: 12 }}>
          {[...seguimiento].reverse().map((movimiento, indice) => (
            <Timeline.Item key={indice} color={movimiento.tipo === "cancelar" ? "red" : "blue"}>
              <div style={{ fontSize: 12 }}>{movimiento.comentario}</div>
              <div style={{ fontSize: 11, color: "#8c8c8c" }}>
                {moment(movimiento.fecha).format("DD/MM/YYYY HH:mm")}
                {movimiento.usuarioNombre ? ` · ${movimiento.usuarioNombre}` : ""}
              </div>
            </Timeline.Item>
          ))}
        </Timeline>
      </DynamicCardForm>
    );
  }

  render() {
    const modo = this.modo;
    const soloLectura = modo === "ver";
    const { rma } = this.state;
    const etiquetaEstado = rma ? ETIQUETA_ESTADO_RMA[rma.estado] : null;
    const editable = rma && ESTADOS_EDITABLES.includes(rma.estado);
    const motivos = [...this.state.motivos];
    if (rma?.motivo && !motivos.includes(rma.motivo)) motivos.push(rma.motivo);

    const titulos = {
      agregar: `Agregar RMA${this.state.folioSugerido ? ` ( ${this.state.folioSugerido} )` : ""}`,
      editar: `Editar RMA${rma?.folio ? ` ( ${rma.folio} )` : ""}`,
      ver: `RMA${rma?.folio ? ` ( ${rma.folio} )` : ""}`,
    };

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={titulos[modo]}
          tags={etiquetaEstado ? <Tag color={etiquetaEstado.color}>{etiquetaEstado.texto}</Tag> : null}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            soloLectura && rma ? (
              <Space>
                <ButtonItem type="default" blanco icon={<MailOutlined />} onClick={() => this.setState({ modalCorreoVisible: true })}>
                  PDF / Correo
                </ButtonItem>
                {editable && (
                  <ButtonItem type="primary" cyan icon={<EditOutlined />} onClick={this.editar.bind(this)}>
                    Editar
                  </ButtonItem>
                )}
              </Space>
            ) : null
          }
        />
        <Spin spinning={this.state.loading}>
          {rma && (
            <div style={{ background: "white", borderRadius: 8, padding: "12px 16px", marginBottom: 12, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" }}>
              <Steps
                size="small"
                current={pasoDeEstado(rma.estado)}
                status={rma.estado === ESTADOS_RMA.CANCELADO || rma.estado === ESTADOS_RMA.RECHAZADO ? "error" : undefined}
              >
                {PASOS_RMA.map((paso) => (
                  <Steps.Step key={paso} title={paso} />
                ))}
              </Steps>
              {rma.estado === ESTADOS_RMA.CANCELADO && (
                <Alert
                  type="error"
                  showIcon
                  style={{ marginTop: 10 }}
                  message={`RMA cancelado${rma.motivoCancelacion ? `: ${rma.motivoCancelacion}` : ""}`}
                />
              )}
            </div>
          )}
          <Form
            ref={this.formRef}
            name="VistaRMA"
            layoutForm="vertical"
            onValuesChange={this.onValuesChange.bind(this)}
          >
            <Row gutter={16}>
              <DynamicCardForm title="Solicitud" xs={24} lg={16}>
                <Row gutter={16}>
                  <Col xs={24} md={16}>
                    <FormItem label="Cliente" name="clienteId" required={!soloLectura} margin>
                      <SelectClientesItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        placeholder="Cliente que devuelve"
                        width="100%"
                        disabled={soloLectura}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={8}>
                    <FormItem label="Fecha de solicitud" name="fechaSolicitud" required={!soloLectura} margin>
                      <DatePickerItem placeholder="Fecha" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem label="Motivo" name="motivo" required={!soloLectura} margin>
                      <SelectItem placeholder="Motivo de la devolución" disabled={soloLectura}>
                        {motivos.map((motivo) => (
                          <Option key={motivo} value={motivo}>
                            {motivo}
                          </Option>
                        ))}
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem label="Contacto" name="contacto" margin>
                      <InputItem placeholder="Quién reporta" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem label="Correo del contacto" name="correoContacto" email margin>
                      <InputItem placeholder="correo@cliente.com" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem label="Teléfono del contacto" name="telefonoContacto" margin>
                      <InputItem placeholder="Teléfono" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <FormItem label="Descripción del problema" name="descripcion" margin>
                  <TextAreaItem rows={3} placeholder="Qué falla, cómo se detectó, etc." disabled={soloLectura} />
                </FormItem>
              </DynamicCardForm>

              {this.renderResumen()}

              <DynamicCardForm
                title={`Renglones${this.state.renglones.length ? ` (${this.state.renglones.length})` : ""}`}
                xs={24}
                headerRight={
                  soloLectura ? null : (
                    <Space onClick={(e) => e.stopPropagation()}>
                      <ButtonItem
                        type="default"
                        size="small"
                        icon={<ShoppingCartOutlined />}
                        onClick={() => {
                          if (!this.state.clienteId) return message.info("Primero elige el cliente");
                          this.setState({ modalVentaVisible: true });
                        }}
                      >
                        Desde una venta
                      </ButtonItem>
                      <ButtonItem
                        type="default"
                        size="small"
                        icon={<PlusOutlined />}
                        onClick={() => this.setState({ modalLibreVisible: true })}
                      >
                        Sin venta
                      </ButtonItem>
                    </Space>
                  )
                }
              >
                {this.state.renglones.length > 0 ? (
                  <Table
                    size="small"
                    rowKey="_llave"
                    dataSource={this.state.renglones}
                    columns={this.columnasRenglones(soloLectura)}
                    pagination={false}
                    scroll={{ x: 900 }}
                    style={{ marginTop: 8 }}
                  />
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={soloLectura ? "Sin renglones" : "Agrega renglones desde una venta del cliente o sin venta"}
                  />
                )}
              </DynamicCardForm>

              <DynamicCardForm
                title={`Evidencias${this.state.evidencias.length ? ` (${this.state.evidencias.length})` : ""}`}
                xs={24}
              >
                {soloLectura && this.state.evidencias.length === 0 && <div style={{ color: "#999" }}>Sin evidencias</div>}
                <Upload
                  multiple
                  fileList={this.state.evidencias}
                  beforeUpload={this.agregarArchivo}
                  onRemove={this.quitarArchivo}
                  onPreview={this.verArchivo}
                  onDownload={this.descargarArchivo}
                  showUploadList={{ showRemoveIcon: !soloLectura, showDownloadIcon: true }}
                >
                  {!soloLectura && (
                    <ButtonItem type="dashed" icon={<UploadOutlined />}>
                      Adjuntar fotos o documentos
                    </ButtonItem>
                  )}
                </Upload>
              </DynamicCardForm>

              {this.renderSeguimiento()}
            </Row>

            {!soloLectura && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10,
                  justifyContent: "flex-end",
                  padding: "14px 16px",
                  background: "white",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                }}
              >
                <ButtonItem type="default" danger onClick={this.atras.bind(this)}>
                  Cancelar
                </ButtonItem>
                <ButtonItem type="primary" onClick={this.guardar.bind(this)}>
                  {modo === "editar" ? "Guardar cambios" : "Crear RMA"}
                </ButtonItem>
              </div>
            )}
          </Form>
        </Spin>

        <ElegirRenglonesVentaRMA
          visible={this.state.modalVentaVisible}
          clienteId={this.state.clienteId}
          rmaId={this.id}
          renglonesActuales={this.state.renglones}
          onAgregar={this.agregarRenglonesDeVenta.bind(this)}
          onCerrar={() => this.setState({ modalVentaVisible: false })}
        />
        <ModalRenglonLibreRMA
          visible={this.state.modalLibreVisible}
          onAgregar={this.agregarRenglonLibre.bind(this)}
          onCerrar={() => this.setState({ modalLibreVisible: false })}
        />
        <MandarCorreoRMA
          visible={this.state.modalCorreoVisible}
          id={this.id}
          onCerrar={() => this.setState({ modalCorreoVisible: false })}
        />
        <ModalPrevisualizarArchivos
          visible={!!this.state.archivoVer}
          file={this.state.archivoVer}
          endpointArchivo={ENDPOINT_ARCHIVO}
          parametrosArchivo={{ rmaId: this.id }}
          onClose={() => this.setState({ archivoVer: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VistaRMA);
